var React = require('react');

function TriangleRightFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 3.5L0.25 6.53109L0.25 0.468911L4 3.5Z","fill":"white"}));
}

TriangleRightFilled.defaultProps = {"width":"4","height":"7","viewBox":"0 0 4 7","fill":"none"};

module.exports = TriangleRightFilled;

TriangleRightFilled.default = TriangleRightFilled;
